// --- NEW FILE: packages/api-client/src/services/public/taskService.ts ---

import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { 
    ServiceResponse,
    ProjectTask,
    UUID,
} from '@dopomogai/types';

// The base URL prefix for all public task operations.
const PUBLIC_TASKS_PREFIX = '/tasks';

/**
 * A collection of service functions for interacting with the public-facing
 * ProjectTask API endpoints.
 */
export const taskService = {
  /**
   * Lists tasks with powerful public filtering. This is the primary endpoint for
   * building dynamic task boards that may show tasks from different sources.
   * @param params Optional filters for the task list.
   */
  listPublicTasks: (params?: { 
    project_id?: UUID; 
    sprint_id?: UUID; 
    unassigned?: boolean; 
  }): ServiceResponse<ProjectTask[]> => {
    return getApiClient().get<ProjectTask[]>(PUBLIC_TASKS_PREFIX, { params })
      .then(res => res.data)
      .catch(err => handleApiError(err, 'listing public tasks'));
  },

  /**
   * Fetches the details of a single public task by its ID.
   * Note: This returns raw task data without a language pack.
   * @param taskId The unique ID of the task.
   */
  getPublicTaskById: (taskId: string): ServiceResponse<ProjectTask> => {
    return getApiClient().get<ProjectTask>(`${PUBLIC_TASKS_PREFIX}/${taskId}`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `fetching task '${taskId}'`));
  },
};